import { Injectable } from '@angular/core';
import { AppPermissions, ProjectInfo } from '@frontend-site/shared/data';
import { ProjectStore } from './project/project.store';
import { SessionRepository } from './session/session.repository';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
    constructor(private session: SessionRepository, private projectStore: ProjectStore) {}

    hasPermissions(permission: string, projectIds: number[] = []): boolean {
        const permissions = this.getPermissions();
        if (this.isUserHasNoPermissions(permissions)) {
            return false;
        }

        const projectInfo = this.projectStore.projectDetails as ProjectInfo;
        this.populateProjectIdsIfNeeded(projectIds, permissions, projectInfo?.id);

        const projectsWithPermission = projectIds.filter((projectId) => {
            const projectPermissions = permissions[projectId];
            if (projectPermissions) {
                return this.isProjectHasPermission(permission, projectPermissions);
            }

            return false;
        });

        return projectsWithPermission.length > 0;
    }

    private getPermissions(): AppPermissions {
        return this.projectStore.projectDetails?.permissions ?? this.session.applicationConfig?.permissions ?? {};
    }

    isUserHasNoPermissions(allUserPermissions: any): boolean {
        return !allUserPermissions || allUserPermissions.length === 0;
    }

    isProjectHasPermission(permission: string, projectPermissions: any): boolean {
        if (permission === undefined) {
            return true;
        }

        let permissionsArr;
        const permissionsList = projectPermissions.map((elem: string) => {
            return elem.replace(/ /g, '').toLowerCase();
        });
        permission = permission.replace(/ /g, '').toLowerCase();
        if (permission.includes('||')) {
            permissionsArr = permission.split('||');
            return permissionsArr.some((elem) => {
                return permissionsList.indexOf(elem) > -1;
            });
        }
        if (permission.includes('&&')) {
            permissionsArr = permission.split('&&');
        } else {
            permissionsArr = [permission];
        }
        return permissionsArr.every((elem) => {
            return permissionsList.indexOf(elem) > -1;
        });
    }

    private populateProjectIdsIfNeeded(projectIds: number[], allUserPermissions: any, projectId: number): void {
        // If no project ids supplied and we are in TC, use the TC project id
        if (!projectIds.length && this.isInTestCenter()) {
            projectIds.push(projectId);
        } else if (this.shouldCheckCompanyLevelPermissions(projectIds)) {
            this.addCompanyProjectsToProjectIds(allUserPermissions, projectIds);
        }
    }

    private isInTestCenter(): boolean {
        return !!this.projectStore.projectDetails;
    }

    private shouldCheckCompanyLevelPermissions(projectIds: number[]): boolean {
        return projectIds.length === 0;
    }

    private addCompanyProjectsToProjectIds(allPermissions: any, projectIds: number[]): void {
        for (const id in allPermissions) {
            if (allPermissions.hasOwnProperty(id)) {
                projectIds.push(+id);
            }
        }
    }
}
